(function($, undefined) {
	
	'use strict';
    var responsiveDetector;
    var desktopActive = true;
    var textOuterCtn;
    var textCtn;
    var showMoreBtnCtn;
    var showMoreBtn;

    var checkWidth = function() {
        if (responsiveDetector.css('visibility') === 'hidden') {
            if (desktopActive === false) {
                $('.show-more-text-and-btn-ctn.mobile-only').each(function() {
                    var t = $(this);
                    t.find(textOuterCtn).removeAttr('style');
                    t.find(showMoreBtnCtn).slideUp(300);
                });
            }

            desktopActive = true;
        } else {
            if (desktopActive === true) {
                $('.show-more-text-and-btn-ctn.mobile-only').each(function() {
                    initShowMoreBtn($(this));
                });
            }

            desktopActive = false;
        }
    };

    var initShowMoreBtn = function(t) {
        if (t.find(textOuterCtn).height() < t.find(textCtn).height()) {
            t.find(showMoreBtnCtn).slideDown(300);
            t.find(showMoreBtn).click(showMoreText);
        }
    };
    
    var showMoreText = function() {
        var t = $(this);
        var parentCtn = t.closest('.show-more-text-and-btn-ctn');
        var currTextOuterCtn = parentCtn.find(textOuterCtn);
        var textHeight = parentCtn.find(textCtn).height();

        currTextOuterCtn.css('max-height', textHeight);
        t.closest(showMoreBtnCtn).slideUp(300);

        setTimeout(function() {
            currTextOuterCtn.css('max-height', 'inherit'); // if resized
        }, 300);
    };

    var init = function() {
        responsiveDetector = $('.responsive-detector');
        textOuterCtn = $('.show-more-text-outer-ctn');
        textCtn = $('.show-more-text-ctn');
        showMoreBtnCtn = $('.show-more-text-btn-ctn');
        showMoreBtn = $('.show-more-text-btn');

        showMoreBtn.click(showMoreText);

        $('.show-more-text-and-btn-ctn:not(.mobile-only)').each(function() {
            initShowMoreBtn($(this));
        });

        checkWidth();
        $(window).resize(function() {
            checkWidth();
        });
	};
	
    $(window).on('load',function(){
        init();
    });
	
})(jQuery);
